import { createSignal, For, onMount } from 'solid-js'
import coinSmall from '~/assets/coin-small.png'
import gemSmall from '~/assets/gem-small.png'
import { flying, type FlyingCoin } from '~/store/reward'

function FlyingCoinItem(props: { coin: FlyingCoin }) {
  const [ready, setReady] = createSignal(false)

  onMount(() => {
    requestAnimationFrame(() => setReady(true))
  })

  const transform = () =>
    ready()
      ? `translate(${props.coin.endX - props.coin.startX}px, ${props.coin.endY - props.coin.startY}px) scale(0.6)`
      : 'translate(0, 0) scale(1)'

  return (
    <img
      src={props.coin.kind === 'gem' ? gemSmall : coinSmall}
      alt=""
      aria-hidden="true"
      draggable={false}
      class="pointer-events-none fixed z-[60] size-6 will-change-transform"
      style={{
        left: `${props.coin.startX - 12}px`,
        top: `${props.coin.startY - 12}px`,
        transform: transform(),
        transition:
          'transform 580ms cubic-bezier(0.55, 0, 0.1, 1), opacity 580ms ease-out',
        opacity: ready() ? 0.4 : 1,
      }}
      onTransitionEnd={() => flying.remove(props.coin.id)}
    />
  )
}

export function FlyingCoinLayer() {
  return (
    <For each={flying.list()}>{(coin) => <FlyingCoinItem coin={coin} />}</For>
  )
}
